export default [
  {
    path: 'estimate',
    name: 'PtoProjectEstimate',
    component: () => import('@/views/Pto/Project/estimate/PtoProjectEstimate.vue')
  },
  {
    path: 'estimate/:id',
    name: 'PtoProjectEstimateUpdate',
    component: () => import('@/views/Pto/Project/estimate/PtoProjectEstimateUpdate.vue')
  },
  {
    path: 'work-sign/:id',
    name: 'PtoProjectWorkSignUpdate',
    component: () => import('@/views/Pto/Project/estimate/PtoProjectWorkSignUpdate.vue'),
    children: [
      {
        path: 'own-production',
        name: 'PtoProjectWorkSignUpdateOwn',
        component: () => import('@/views/Pto/Project/estimate/PtoProjectOwnProduction.vue')
      },
      {
        path: 'fot-production',
        name: 'PtoProjectWorkSignUpdateFot',
        component: () => import('@/views/Pto/Project/estimate/PtoProjectFotProduction.vue')
      }
    ]
  },
  {
    path: 'own-production/:id',
    name: 'PtoProjectOwnProductionUpdate',
    component: () => import('@/views/Pto/Project/estimate/PtoProjectOwnProductionUpdate.vue')
  },
  {
    path: 'fot-production/:id',
    name: 'PtoProjectFotProductionUpdate',
    component: () => import('@/views/Pto/Project/estimate/PtoProjectFotProductionUpdate.vue')
  }
]
